import { connect } from "react-redux";
import { Person } from "./person";
import { bindActionCreators } from "redux";
import { fetchPerson } from "../../../store/thunks/person";

const mapStateToProps = state => {
  return {
    person: state.personState
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchPerson: bindActionCreators(fetchPerson, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Person);
